import moment from 'moment'

import getState from '@/modules/todo/components/_helpers/getState'
import store from '@/redux/store'
import todoTypesEnum from '@/enums/todo-types.enum'

const EMPTY_PROP = '–'
export default class TodoListModel {
  constructor(data) {
    const { status, dueFromDate, dueToDate, clientName, clientNumber } = data
    const { subscriptions } = store.getState().tenant.info
    const isTaxConsultant = subscriptions?.some(s => s.isTaxConsultant)

    this.id = data.id || undefined
    this.title = data.title || EMPTY_PROP
    this.type = data.type
    this.status = data.status
    this.content = data.content || EMPTY_PROP
    this.responsible = data.type === todoTypesEnum.SIGNATURE
      ? data.signers?.length > 1
        ? `${data.signers[0]} + ${data.signers.length - 1}`
        : data.signers[0]
      : data.responsible ? data.responsible : EMPTY_PROP
    this.responsibleId = data.responsibleId
    this.isReadOnly = data.isReadOnly
    this.isOwner = data.isOwner
    this.createdAt = data.createdAt
      ? moment(data.createdAt)
      : null
    this.updatedAt = data.updatedAt
      ? moment(data.updatedAt)
      : null
    this.dueToDate = data.dueToDate
      ? moment(data.dueToDate)
      : null
    this.dueFromDate = data.dueFromDate
      ? moment(data.dueFromDate)
      : null
    this.status = getState({ status, dueFromDate, dueToDate })
    this.menu = ''
    if (isTaxConsultant) {
      this.clientName = clientName || EMPTY_PROP
      this.clientNumber = clientNumber || EMPTY_PROP
    }
    this.isSeen = data.isSeen
    this.users = data.users || []
    this.messageCount = data.messageCount
  }
}
